import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import 'core-js/stable';
import store from './store';
import Routes from './routes';
import App from './components/App/App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { validateEnv } from './utils/envValidation';
import { hotjar } from './utils';
import { unregister } from './registerServiceWorker';
import './index.scss';

// Validate environment variables on app startup
validateEnv();

hotjar(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_SNIPPET_VERSION);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConfigProvider>
        <App>
          <Routes />
        </App>
      </ConfigProvider>
    </Provider>
  </ErrorBoundary>
);

unregister();
